export enum CameraApiTagType {
  Cameras = "Cameras",
  Streams = "Streams",
  StreamControl = "StreamControl",
  StreamControlCapabilities = "StreamControlCapabilities",
  NN = "NN",
  Dashboard = "Dashboard",
  Reports = "Reports",
  Events = "Events",
  Sessions = "Sessions",
  StreamConfig = "StreamConfig",
}
